import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Log } from '@src/app/models/log';
import { Person } from '@src/app/models/person';
import { PersonOrganization } from '@src/app/models/personorganization';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http:HttpClient) { }

  getLogs(from:string,to:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    
    return this.http.get<Log[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/log/from/'+from+'/to/'+to,httpOptions);
  }

  getPerson(personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Person>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId,httpOptions);
  }
}
